import store from '../store/store'
import jwt from 'jsonwebtoken'

export const authenticated = (to, from, next) => {
  jwt.verify(store.getters.getToken, process.env.VUE_APP_JWT_SECRET, (err, decoded) => {
    if (err && err.name === 'TokenExpiredError') {
      store.dispatch('clearState')

      return next({ name: 'login-enter' })
    }
  })

  if (store.getters.authenticated) {
    return next()
  }

  return next({ name: 'login-enter' })
}

export const hasPermission = (to, from, next) => {
  let permissions = store.getters.permissions,
    routePermissions = to.meta.permissions

  let go = routePermissions.find(permission => {
    return permissions[permission] === true
  })

  if (go) {
    return next()
  }

  return next({ name: 'course-list' })
}

export const courseOwner = async(to, from, next) => {
  try {
    axios.get(`/course/check/${to.params.course_id}`).then(response => {
      if (response.data.success && response.data.check) {
        return next()
      }

      return next({ name: 'course-list' })
    }).catch(console.error)


  } catch (err) {
    console.error(err)

    return next({ name: 'course-list' })
  }
}
